import React, { FunctionComponent, ReactElement, memo, useMemo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { PercentageType, PixelType, ResponsiveType } from '@sport1/react-elements/Types'
import { filterAndMapProps } from '../../../../DesignSystem/utils/filterAndMapProps'
import { SystemSpacingsProps } from '../../../../DesignSystem/spacings/types'
import { spacings } from '../../../../DesignSystem/spacings'
import { RadiusVariants } from '../../../../DesignSystem/border/radius/types'
import { getFontColorByBackgroundColor } from '../../../../utils/Colors'
import { ButtonTypes } from '../ButtonTypes'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import LinkProps from '../../../../Link/LinkProps'
import Font from '@/Fonts/Font'

interface BasicButtonProps extends SystemSpacingsProps, ButtonTypes, LinkProps, TestID {
    children: string
    href?: string
    onPress?: () => void
    expand?: boolean
    height?: number | PixelType | PercentageType
    borderRadius?: ResponsiveType<keyof RadiusVariants>
    uppercase?: boolean
    iconName?: 'play_arrow'
}

const BasicButton: FunctionComponent<BasicButtonProps> = ({
    children,
    backgroundColor = 'pearl',
    href,
    onPress,
    expand = false,
    paddingX,
    paddingY,
    height,
    borderRadius,
    uppercase = true,
    iconName,
    testID,
    webRel,
    webTarget,
    ...rest
}): ReactElement => {
    const buttonFont = useMemo(() => {
        return (
            <Font
                fontVariant="Body-L"
                fontFamilyVariant="Sport1-CondensedBlackItalic"
                color={getFontColorByBackgroundColor(backgroundColor)}
                uppercase={uppercase}
            >
                {children}
            </Font>
        )
    }, [children, backgroundColor, uppercase])
    return (
        <Grid horizontal={!expand} noExpand testID={testID} {...filterAndMapProps(rest)}>
            <Touchable onPress={onPress} href={href} webRel={webRel} webTarget={webTarget}>
                <Grid
                    backgroundColor={backgroundColor}
                    {...filterAndMapProps({ paddingX, paddingY, borderRadius })}
                    noExpand
                    height={height}
                    center
                >
                    {iconName ? (
                        <Grid noExpand horizontal>
                            <Grid marginRight={spacings['spacing-6']} noExpand>
                                <FontelloIcon
                                    name={iconName}
                                    color={getFontColorByBackgroundColor(backgroundColor)}
                                />
                            </Grid>
                            {buttonFont}
                        </Grid>
                    ) : (
                        buttonFont
                    )}
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(BasicButton)
